<ziro-collapsible-section-card
  [attr.data-automation]="dataAutomation()"
  [isSwitchHidden]="true"
  [isCollapsible]="false"
  [title]="'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.greetings.header'"
  [subtext]="'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.greetings.help_text'"
>
  <div class="row align-items-start g-3">
    <div class="col-12 col-md-5">
      <ziro-radio [fieldId]="'greetings'"></ziro-radio>
    </div>

    <div class="col-12 col-md-7">
      <div [hidden]="formData.greetings !== CallFlowGreetingsOptions.CUSTOM_GREETING">
        <ziro-file-upload [fieldId]="'greetingUpload'"></ziro-file-upload>
        @if (!isGreetingLoading() && greetingUploadURL() && acceptedFileTypes.includes(greetingFileExtension())) {
          <audio
            [attr.data-automation]="'greeting-audio'"
            class="mt-2 w-100"
            controls
            [src]="greetingUploadURL()"
            [title]="greetingDownloadName()"
          ></audio>
        }
      </div>

      <ziro-textarea
        [fieldId]="'greetingTtsMessage'"
        [hidden]="formData.greetings !== CallFlowGreetingsOptions.TTS_MESSAGE"
      ></ziro-textarea>
    </div>
  </div>
</ziro-collapsible-section-card>
